import '../../../../assets/css/ReviewPopup.css'; 
import RatingStars from "../../../../components/RatingStars";
import {format } from 'date-fns';

const ReviewPopup = ({ review, onClose }) => {
    if (!review) return null;

    return (
        <div className="review-popup">
            <div className="new-popup-content">
                <button className="close-popup" onClick={onClose}>&times;</button>
                <div className="review-popup-header">
                    <div className="new-reviews-profile">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}
                    </div>
                    <h3>{review.name} <span>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span></h3>
                </div>
                <p><RatingStars average_rating={review.rating} /></p>
                <p>{ review.description }</p>
            </div>
        </div>
    );
};

export default ReviewPopup;
